// react
import { type ReactNode } from 'react';

// material ui icons
import CloseIcon from '@mui/icons-material/Close';

// material ui
import { Alert, AlertTitle, Collapse, IconButton, Stack } from '@mui/material';

interface Props {
  open: boolean;
  severity: 'success' | 'info' | 'warning' | 'error';
  title?: string;
  message?: ReactNode;
  action?: ReactNode;
  onClose?: () => void;
}

export default function GlobalAlert({
  open,
  severity,
  title,
  message,
  action,
  onClose,
}: Props) {
  const alertAction =
    action || onClose ? (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {action}
        {onClose && (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>
    ) : undefined;

  return (
    <Collapse in={open} timeout={100} unmountOnExit>
      <Alert severity={severity} sx={{ borderRadius: 0 }} action={alertAction}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Collapse>
  );
}
